import { useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { textSizes } from '../../config/config';
import { cn } from '../../utils/utils';

const Text = ({
  text = '',
  weight,
  size,
  className,
  style,
  onClick,
  align,
  dir,
  isRequired = false,
  isDisabled = false,
  isEmpty = false,
}) => {
  const { TextWeight, TextAlign, isArabic } = dynamicfunction();
  const fontsize = useSelector((state) => state.content?.fontsize);

  const getSize = () => {
    if (fontsize === textSizes.small) {
      return size ? Number(size) - 2 : 10;
    } else if (fontsize === textSizes.medium) {
      return size ? Number(size) : 12;
    } else if (fontsize === textSizes.large) {
      return size ? Number(size) + 2 : 14;
    }
  };

  return (
    <p
      data-required-empty={isEmpty || undefined}
      style={{
        fontSize: getSize(),
        ...style,
      }}
      className={cn(isDisabled ? 'text-dark-grey/60' : 'text-dark-grey', weight ?? TextWeight.medium, align ?? TextAlign, className)}
      onClick={isDisabled ? null : onClick}
      dir={dir ? dir : isArabic ? 'rtl' : 'ltr'}
    >
      {text}
      {isRequired && <span className='text-red-500'>*</span>}
    </p>
  );
};

export default Text;
